import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { StructuredTextPropTypes } from 'dpl/prismic/utils/customPropTypes';
import { ARTICLE_CONTENT_COL_CLASSES } from 'dpl/prismic/article/utils/constants';

import { normalizeTable } from '../utils';
import TableRow from './TableRow';

export default function Table({ sliceData }) {
  const { items: rows } = sliceData;

  const table = useMemo(() => normalizeTable(rows), [sliceData.items.length]);

  // all columns are empty!  whatcha doing, creative team????
  if (table.length === 0) {
    return null;
  }

  const [headerRow, ...restRows] = table;

  return (
    <div className="PrismicTable container">
      <div className="row">
        <div className={ARTICLE_CONTENT_COL_CLASSES}>
          <table className="dt--fixed tl">
            <thead>
              <TableRow isHead row={headerRow} />
            </thead>
            <tbody>
              {restRows.map((row, idx) => (
                <TableRow
                  isLast={idx === restRows.length - 1}
                  key={idx}
                  row={row}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

Table.propTypes = {
  sliceData: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        col1: StructuredTextPropTypes,
        col2: StructuredTextPropTypes,
        col3: StructuredTextPropTypes,
        col4: StructuredTextPropTypes,
        col5: StructuredTextPropTypes
      })
    ).isRequired
  }).isRequired
};
